import {Component, Inject} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {UserCardService} from "../../service/user-card.service";
import {SharedConstants} from "../../utilityClass/sharedConstants";

@Component({
  selector: 'app-user-card-username-edit',
  templateUrl: './user-card-username-edit.component.html',
  styleUrl: './user-card-username-edit.component.scss'
})
export class UserCardUsernameEditComponent {

  readonly ALREADY_EXISTS_ERROR_TEXT = 'Card with this username already exists.';
  readonly WRONG_NAME_LONG_ERROR_TEXT = 'Invalid username.';

  form: FormGroup;
  errorMessage: string | null = null;

  protected readonly SharedConstants = SharedConstants;

  constructor(
    protected dialogRef: MatDialogRef<UserCardUsernameEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      cardId: string
      id: bigint
    },
    private userCardService: UserCardService,
    private formBuilder: FormBuilder,
  ) {
    this.form = this.formBuilder.group({
      newUsername: [this.ensureAtSymbol(data.cardId), [Validators.required, this.usernameValidator]]
    });
    this.form.get('newUsername')?.valueChanges.subscribe(value => {
      this.form.get('newUsername')?.setValue(this.ensureAtSymbol(value), { emitEvent: false });
    });
  }

  onInputSpaceChange(event: Event, controlName: string): void {
    const input = event.target as HTMLInputElement;
    let cleanValue = input.value.replace(/\s/g, '');

    if (cleanValue.startsWith('@')) {
      cleanValue = '@' + cleanValue.slice(1).replace(/@/g, '');
    } else {
      cleanValue = cleanValue.replace(/@/g, '');
    }

    this.editUserNameControl[controlName].setValue(cleanValue);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  edit(): void {
    this.errorMessage = null;

    if (this.form.valid) {
      const newUsername = this.form.value.newUsername;
      if (newUsername !== this.data.cardId) {
        this.userCardService.editCardId(this.data.id, newUsername).subscribe({
          next: () => {
            this.dialogRef.close({cardId: newUsername, id: this.data.id});
          },
          error: () => {
            this.errorMessage = this.ALREADY_EXISTS_ERROR_TEXT;
          }
        });
      } else {
        this.dialogRef.close({cardId: newUsername, id: this.data.id});
      }
    } else {
      this.errorMessage = this.WRONG_NAME_LONG_ERROR_TEXT;
    }
  }

  private ensureAtSymbol(value: string): string {
    if (!value.startsWith('@')) {
      return '@' + value;
    }
    return value;
  }

  private usernameValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value.startsWith('@')) {
      return { invalidUsername: true };
    }
    return null;
  }

  get editUserNameControl() {
    return this.form.controls;
  }
}
